<p>footer-action-buttons works!</p>
